<sbf-error-shell [errorNumber]="405" message1="BAD REQUEST" message2="KEEP EXPLORING"></sbf-error-shell>
